import { IsBoolean, IsDateString, IsString } from 'class-validator';

import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

export class ThreadsConfig {
  @IsBoolean()
  enabled: boolean;

  @IsString()
  enabledBy: string;

  @IsDateString()
  enabledOn: string;
}

const threadsConfigurationResource = createDocumentResource<ThreadsConfig>({
  name: 'threadsConfiguration',
  endpoint: 'v1/orgs/:orgId/configuration/threads',
  type: ThreadsConfig,
  observerCreator: emptyObserverCreator,
});

export default threadsConfigurationResource;
